/**
 * Browser-only polyfills loaded ahead of the Inertia app so the bundle's
 * runtime APIs (Promise.allSettled, Object.fromEntries, etc.) exist on the
 * ~2020-era browsers we support. `build.target` in vite.config.js handles
 * syntax transpilation; core-js fills the missing-API gap that target cannot.
 *
 * This entry is wired through the @vite() Blade directive only, so it never
 * enters the Inertia SSR bundle (which boots from resources/js/app.js).
 */
import 'core-js/stable'
